import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../../components/SearchBar";

const FoundersPass = () => {
    const navigate = useNavigate();

    // Example Data (Replace with API Data Later)
    const founders = [
        {
            id: 1,
            userName: "Sarah Ahmed",
            userEmail: "sarah.ahmed@example.com",
            industry: "Tech & Innovation",
            startDate: "10-10-2025",
            daysLeft: 285,
            expiryDate: "10-10-2026",
            joinedDate: "15-10-2025",
            status: "Active",
            location: "Dubai, UAE",
            bio: "Serial entrepreneur focused on fintech solutions.",
        },
        {
            id: 2,
            userName: "James Wilson",
            userEmail: "james.wilson@example.com",
            industry: "Retail & E-commerce",
            startDate: "01-11-2025",
            daysLeft: 310,
            expiryDate: "01-11-2026",
            joinedDate: "02-11-2025",
            status: "Active",
            location: "London, UK",
            bio: "Founder of a high-growth D2C lifestyle brand.",
        },
    ];

    return (
        <>
            <div className="main_title">
                <h1>Founder's Pass</h1>
            </div>
            <div className="table_flex">
                <div className="lt">

                    <div className="cards">
                        <div className="table_header">
                            <div className="left_s">
                                <SearchBar
                                    searchTerm={""}
                                    setDebouncedSearchTerm={() => { }}
                                    placeholder="Search Founders..."
                                />
                            </div>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr. No</TableCell>
                                        <TableCell>User Details</TableCell>
                                        <TableCell>Industry</TableCell>
                                        <TableCell>Founder Pass Start Date</TableCell>
                                        <TableCell>Days Left</TableCell>
                                        <TableCell>Expiry Date</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {founders.map((item, index) => (
                                        <TableRow hover key={item.id}>
                                            <TableCell>{index + 1}</TableCell>

                                            {/* Founder Details */}
                                            <TableCell>
                                                <div>
                                                    <strong>{item.userName}</strong>
                                                    <p style={{ margin: 0, fontSize: "0.85rem", color: "#666" }}>
                                                        {item.userEmail}
                                                    </p>
                                                </div>
                                            </TableCell>

                                            <TableCell>{item.industry}</TableCell>
                                            <TableCell>{item.startDate}</TableCell>
                                            <TableCell>
                                                <span className={`badge1 ${item.daysLeft < 30 ? 'danger' : 'success'}`}>
                                                    {item.daysLeft} Days
                                                </span>
                                            </TableCell>
                                            <TableCell>{item.expiryDate}</TableCell>
                                            <TableCell>
                                                <span className="status_chip active">{item.status}</span>
                                            </TableCell>
                                            <TableCell>{item.location}</TableCell>

                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <IconButton onClick={() => navigate("/fikra-lab-business-report/view")}>
                                                        <img
                                                            src="/static/images/eye_icon.svg"
                                                            alt="View"
                                                        />
                                                    </IconButton>
                                                    <IconButton>
                                                        <img
                                                            src="/static/images/trash2_icon.svg"
                                                            alt="Delete"
                                                        />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default FoundersPass;
